import { FC } from 'react';
import { matchPath, useLocation } from 'react-router';

import { useCollapsed, useSetCollapsed } from '~features/shared/collapse';

import { useTranslation } from '~shared/lib/i18n';
import { useMobileAuthTheme } from '~shared/lib/mobile-auth';
import { RoutesUrls } from '~shared/lib/router';
import { Header, Logo, MenuIcon, useWindowInnerWidth } from '~shared/ui';

export interface AppHeaderProps extends Partial<ComponentWithChild> {}

export const AppHeader: FC<AppHeaderProps> = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const windoWidth = useWindowInnerWidth();
  const collapsed = useCollapsed();
  const setCollapsed = useSetCollapsed();
  const useThemMode = useMobileAuthTheme();

  const handleCollapse = () => {
    setCollapsed(!collapsed);
  };

  // Try to match dynamic routes first
  let pageKey: string | undefined;

  for (const [key, path] of Object.entries(RoutesUrls)) {
    if (matchPath(path, location.pathname)) {
      pageKey = key;
      break;
    }
  }

  // Fallback to old logic if no match found
  if (!pageKey) {
    pageKey =
      Object.keys(RoutesUrls)[
        Object.values(RoutesUrls).indexOf(location.pathname.split('/').slice(0, 4).join('/') as any)
      ];
  }

  // /* eslint-disable no-console */
  // console.warn(pageKey);

  return (
    <Header>
      {windoWidth > 768 ? (
        <p className="text-[14px]">{t(`cm:pages.${pageKey}`) as string}</p>
      ) : (
        <div className="flex justify-between w-full items-center">
          <div className="flex items-center gap-5">
            <Logo collased={false} />
            <p className="text-[14px]">{t(`cm:pages.${pageKey}`) as string}</p>
          </div>
          <div onClick={handleCollapse} className="cursor-pointer flex items-center">
            <MenuIcon isDark={useThemMode === 'dark'} />
          </div>
        </div>
      )}
    </Header>
  );
};
